import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


//NProgress
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

// element-ui
import ElementUI from 'element-ui';
Vue.use(ElementUI, { size: 'small', });

 

//avue
import Avue from '@smallwei/avue';
import '@smallwei/avue/lib/index.css';
Vue.use(Avue);

// icon
import './assets/icons' 

import Fragment from 'vue-fragment'
Vue.use(Fragment.Plugin)

//载入mixin
// import mixins from '@/mixins/'
// Vue.mixin({
//   ...mixins
// })

import { info } from '@/apis/oms/common'
import { info as be_info } from '@/apis/backend/common'

router.beforeEach((to, from, next) => {
  //判断是否登录
  let path = to.path;

  //如果是b端后台获取子域名参数
  if (path == '/' && process.env.VUE_APP_TYPE) { 
    let subDomain = to.query.subDomain;
    if (subDomain && subDomain != '') {
      store.dispatch('update_subDomain', subDomain);
    }
  }
  if (path.indexOf('/login') === -1) {
    if (store.state.userInfo.token == null) {
      var loginUrl = '/login/';
      router.push({ path: loginUrl });
    } else {
      if (store.state.userInfo.user) {
        NProgress.start()
        next()
      } else { 
        let infoAPI = process.env.VUE_APP_TYPE == 'oms' ? info : be_info;
        infoAPI().then(data => { 
          store.dispatch('update_userinfo', data).then(res => {
            NProgress.start()
            next()
          })
        })
      }
    }
  } else {
    NProgress.start()
    next()
  }
})

router.afterEach(() => {
  NProgress.done()
})

Vue.config.productionTip = false

//注册地区控件
import areaCascader from './components/area.vue';
Vue.component('areaCascader', areaCascader);

//下拉树控件
import SelectTree from './components/SelectTree.vue';
Vue.component('SelectTree', SelectTree);

//分页控件
import Pagination from './components/Pagination.vue';
Vue.component('Pagination', Pagination);

Vue.config.productionTip = false

console.log(process.env.VUE_APP_BASEPATH);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
